<mat-drawer-container class="example-container" autosize>
  <!-- Premium Sidebar -->
  <mat-drawer #drawer class="sidebar-drawer tw-w-screen sm:tw-w-[340px]" mode="over">

    <!-- Sidebar Header: Brand + Close -->
    <div class="sidebar-header">
      <div class="sidebar-brand">
        <div class="brand-info">
          <span class="brand-name">Maedah</span>
          <span class="brand-tagline">{{ 'Restaurant Portal' | translate }}</span>
        </div>
      </div>
      <button class="sidebar-close-btn" (click)="drawer.toggle()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>

    <!-- Divider -->
    <div class="sidebar-divider"></div>

    <!-- Context Info (Admin: Company/Restaurant/Branch selectors) -->
    <div class="sidebar-context" *ngIf="userType === 'admin'">
      <div class="context-group" *ngIf="companyService.companies && companyService.companies.length > 1">
        <label class="context-label">
          <nb-icon icon="briefcase-outline" class="context-icon"></nb-icon>
          {{ 'Select Company' | translate }}
        </label>
        <select class="sidebar-select" [(ngModel)]="selectedCompany" (change)="setCompany($event)">
          <option *ngFor="let item of companyService.companies" [ngValue]="item">{{ item.name }}</option>
        </select>
      </div>

      <div class="context-group" *ngIf="restaurantService.restaurants">
        <label class="context-label">
          <nb-icon icon="home-outline" class="context-icon"></nb-icon>
          {{ 'Restaurant' | translate }}
        </label>
        <p class="context-value" *ngIf="restaurantService.restaurants.length === 1">{{ restaurantService.restaurants[0].name }}</p>
        <select *ngIf="restaurantService.restaurants.length > 1" class="sidebar-select"
          [(ngModel)]="selectedRestaurant" (ngModelChange)="setRestaurant($event)">
          <option *ngFor="let item of restaurantService.restaurants" [ngValue]="item">{{ item.name }}</option>
        </select>
      </div>

      <div class="context-group" *ngIf="branches">
        <label class="context-label">
          <nb-icon icon="pin-outline" class="context-icon"></nb-icon>
          {{ 'Branch' | translate }}
        </label>
        <p class="context-value" *ngIf="branches.length === 1">{{ branches[0].name }}</p>
        <select *ngIf="branches.length > 1" class="sidebar-select" [(ngModel)]="selectedBranch" (ngModelChange)="setBranch($event)">
          <option *ngFor="let item of branches" [ngValue]="item">{{ item.name }}</option>
        </select>
      </div>
    </div>

    <!-- Staff Context Info -->
    <div class="sidebar-context" *ngIf="userType !== 'admin' && staff?.length">
      <div class="context-group">
        <label class="context-label">
          <nb-icon icon="home-outline" class="context-icon"></nb-icon>
          {{ 'Restaurant' | translate }}
        </label>
        <p class="context-value">{{ selectedStaff?.restaurant?.name || staff[0].restaurant.name }}</p>
      </div>
      <div class="context-group">
        <label class="context-label">
          <nb-icon icon="pin-outline" class="context-icon"></nb-icon>
          {{ 'Branch' | translate }}
        </label>
        <p class="context-value" *ngIf="branches.length === 1">{{ branches[0].name }}</p>
        <select *ngIf="branches.length > 1" class="sidebar-select" [(ngModel)]="selectedBranch" (ngModelChange)="setStaffBranch($event)">
          <option *ngFor="let item of branches" [ngValue]="item">{{ item.name }}</option>
        </select>
      </div>
    </div>

    <div class="sidebar-divider" *ngIf="userType === 'admin' || (userType !== 'admin' && staff)"></div>

    <!-- Navigation Menu Label -->
    <div class="sidebar-nav-label">{{ 'Navigation' | translate }}</div>

    <!-- Nav Items -->
    <nav class="sidebar-nav">
      @for (item of mobileMenuItems; track $index) {
        <app-mobile-menu-item
          *ngIf="item.permission"
          (click)="drawer.toggle()"
          [label]="item.label"
          [icon]="item.icon"
          [route]="item.route"
          [clickCallback]="item.clickCallback">
        </app-mobile-menu-item>
      }
    </nav>

    <!-- Sidebar Footer -->
    <div class="sidebar-footer">
      <div class="sidebar-divider"></div>
      <div class="sidebar-footer-actions" [ngClass]="{'rtl': language.isArabic}">
        <div ngbDropdown placement="top-start" class="tw-w-full">
          <button class="sidebar-action-btn" ngbDropdownToggle>
            <nb-icon icon="settings-2-outline" class="action-icon"></nb-icon>
            <span>{{ 'Settings' | translate }}</span>
          </button>
          <div class="sidebar-dropdown" ngbDropdownMenu>
            <button ngbDropdownItem (click)="userProfile()">
              <nb-icon icon="person-outline"></nb-icon>
              {{ 'Profile' | translate }}
            </button>
            <button ngbDropdownItem>
              <app-switcher-language></app-switcher-language>
            </button>
            <button ngbDropdownItem (click)="appVersion()">
              <nb-icon icon="info-outline"></nb-icon>
              {{ 'App version' | translate }}
            </button>
            <button ngbDropdownItem (click)="toggleNotifications()">
              <nb-icon [icon]="notificationsEnabled ? 'bell-off-outline' : 'bell-outline'"></nb-icon>
              <span *ngIf="notificationsEnabled">{{ 'Disable Notifications' | translate }}</span>
              <span *ngIf="!notificationsEnabled">{{ 'Enable Notifications' | translate }}</span>
            </button>
            <div class="sidebar-dropdown-divider"></div>
            <button ngbDropdownItem class="logout-item" (click)="logout()">
              <nb-icon icon="log-out-outline"></nb-icon>
              {{ 'Logout' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </mat-drawer>

  <!-- Main Content Area -->
  <div class="main-content-area">
    <!-- Top Navbar -->
    <div class="top-navbar">
      <button class="navbar-menu-btn" (click)="drawer.toggle()">
        <nb-icon icon="menu-outline"></nb-icon>
      </button>
      <div class="navbar-page-title">
        <span class="page-title-text">{{ pageName | translate }}</span>
      </div>
      <div class="navbar-actions">
        <span *ngIf="currentBranchName" class="navbar-branch-chip" [title]="currentBranchName">
          <nb-icon icon="pin-outline"></nb-icon>
          <span>{{ currentBranchName }}</span>
        </span>
        <app-notifications [disabled]="!restaurant || !branch"></app-notifications>
      </div>
    </div>
    <!-- Page Content -->
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
</mat-drawer-container>
